module.exports = __webpack_public_path__ + "img/9788979662016.1069f6d6.jpg";